export default __webpack_public_path__ + "static/icon-brain-black-89966f2678f42822cdb851f40655ae19.svg";